import type { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from './LoginModal';

interface PrivateRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
}

const PrivateRoute = ({ children, requireAuth = true }: PrivateRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();

  // 認証が不要な場合は通常通り表示
  if (!requireAuth) {
    return <>{children}</>;
  }

  // ローディング中は何も表示しない
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // 認証されていない場合はログインモーダルを表示
  if (!isAuthenticated) {
    return <LoginModal />;
  }

  // 認証されている場合は子コンポーネントを表示
  return <>{children}</>;
};

export default PrivateRoute;
